import React, { Component } from 'react';
import { Input, Loader, Dimmer, Header, Container, Dropdown } from 'semantic-ui-react';
import Slider from 'rc-slider';
import SiteMap from '../components/SiteMap';
import 'rc-slider/assets/index.css';
import { connect } from 'react-redux';
import { setUpstreamMIR, setDownstreamMIR, setServiceType, getPrices, selectNetwork } from '../actions/PriceCalculator';
import { push } from 'react-router-redux';

const calculatePrice = (state) => {
  const baseprice = 25;
  var price = 0;
  var mod = 0;
  var dura = 0;
  const { downstream_mir, upstream_mir, service_type, network_name, modulation, duration } = state;
  //const sharedOffset = service_type.indexOf('shared-')  //indexOf gibt die position von shared in service type zurück

  if(modulation.indexOf('13.8')===0){
    mod=1;
  }
  

  else if (modulation.indexOf('11.9') === 0) {

   mod = 1.14;


  }
  else if (modulation.indexOf('10.8') === 0) {

    
    mod = 1.32;

  }
  else if (modulation.indexOf('6.6') === 0) {

  
    mod = 1.98;

  }

  if (duration.indexOf('12') === 0) {

    dura = 1;



  }

  else if (duration.indexOf('6') === 0) {

    dura = 1.04;

   
  }

  else if (duration.indexOf('1') === 0) {

    dura = 1.08;

  }

  if (network_name === 'Hylas2 Afghanistan' || network_name === 'Hylas2 Iraq' || network_name === 'Hylas2 Lybia') {


    if (service_type.indexOf('dedicated') === 0) {


      price = (baseprice + (((downstream_mir * 1 / 1) + ((downstream_mir - downstream_mir * 1 / 1) * 0.02)) * 600 / 1000) *mod+ (((upstream_mir * 1 / 1) + ((upstream_mir - upstream_mir * 1 / 1) * 0.02)) * 900 / 1000)) * dura;

      return Math.round(price * 100)/100;    }
    else if (service_type.indexOf('shared-2') === 0) {


      price = (baseprice + (((downstream_mir * 1 / 2) + ((downstream_mir - downstream_mir * 1 / 2) * 0.02)) * 600 / 1000) *mod+ (((upstream_mir * 1 / 2) + ((upstream_mir - upstream_mir * 1 / 2) * 0.02)) * 900 / 1000))*dura;

      return Math.round(price * 100)/100;    }

    else if (service_type.indexOf('shared-4') === 0) {


      price = (baseprice + (((downstream_mir  * 1/4) + ((downstream_mir - downstream_mir * 1/4) * 0.02)) * 600 / 1000) *mod+ (((upstream_mir *1/4 ) + ((upstream_mir - upstream_mir *1/ 4) * 0.02)) * 900 / 1000))*dura;

      return Math.round(price * 100)/100;    }

    else if (service_type.indexOf('shared-10') === 0) {


      price = (baseprice + (((downstream_mir * 1 / 10) + ((downstream_mir - downstream_mir * 1 / 10) * 0.02)) * 600 / 1000) *mod+ (((upstream_mir * 1 / 10) + ((upstream_mir - upstream_mir * 1 / 10) * 0.02)) * 900 / 1000))*dura;

      return Math.round(price * 100)/100;    }

    


   
    // else {

    //   return(price);
    // }

  }// ende hylas



  else if (network_name === 'Eutelsat 21B') {



    if (service_type.indexOf('dedicated') === 0) {


      price = (baseprice + (((downstream_mir * 1 / 1) + ((downstream_mir - downstream_mir * 1 / 1) * 0.02)) * 1100 / 1000) * mod+ (((upstream_mir * 1 / 1) + ((upstream_mir - upstream_mir * 1 / 1) * 0.02)) * 2200 / 1000))* dura;

      return Math.round(price * 100)/100;    }
    else if (service_type.indexOf('shared-2') === 0) {


      price = (baseprice + (((downstream_mir * 1 / 2) + ((downstream_mir - downstream_mir * 1 / 2) * 0.02)) * 1100 / 1000)*mod + (((upstream_mir * 1 / 2) + ((upstream_mir - upstream_mir * 1 / 2) * 0.02)) * 2200 / 1000))*dura;

      return Math.round(price * 100)/100;    }

    else if (service_type.indexOf('shared-4') === 0) {


      price = (baseprice + (((downstream_mir * 1 / 4) + ((downstream_mir - downstream_mir * 1 / 4) * 0.02)) * 1100 / 1000)*mod+ (((upstream_mir * 1 / 4) + ((upstream_mir - upstream_mir * 1 / 4) * 0.02)) * 2200 / 1000))*dura ;

      return Math.round(price * 100)/100;    }

    else if (service_type.indexOf('shared-10') === 0) {


      price = ((baseprice + (((downstream_mir * 1 / 10) + ((downstream_mir - downstream_mir * 1 / 10) * 0.02)) * 1100 / 1000) * mod + (((upstream_mir * 1 / 10) + ((upstream_mir - upstream_mir * 1 / 10) * 0.02)) * 2200 / 1000)) * dura);

      return Math.round(price * 100)/100;    }



  }//ende e21b

  else if (network_name === 'T11N Africa') {


    if (service_type.indexOf('dedicated') === 0) {


      price = (baseprice + (((downstream_mir * 1 / 1) + ((downstream_mir - downstream_mir * 1 / 1) * 0.02)) * 950 / 1000) *mod+ (((upstream_mir * 1 / 1) + ((upstream_mir - upstream_mir * 1 / 1) * 0.02)) * 2100 / 1000))*dura;

      return Math.round(price * 100)/100;
    }
    else if (service_type.indexOf('shared-2') === 0) {


      price = (baseprice + (((downstream_mir * 1 / 2) + ((downstream_mir - downstream_mir * 1 / 2) * 0.02)) * 950 / 1000) * mod+ (((upstream_mir * 1 / 2) + ((upstream_mir - upstream_mir * 1 / 2) * 0.02)) * 2100 / 1000))*dura;

      return Math.round(price * 100)/100;    }

    else if (service_type.indexOf('shared-4') === 0) {


      price = (baseprice + (((downstream_mir * 1 / 4) + ((downstream_mir - downstream_mir * 1 / 4) * 0.02)) * 950 / 1000)*mod+ (((upstream_mir * 1 / 4) + ((upstream_mir - upstream_mir * 1 / 4) * 0.02)) * 2100 / 1000))*dura;

      return Math.round(price * 100)/100;    }

    else if (service_type.indexOf('shared-10') === 0) {


      price = (baseprice + (((downstream_mir * 1 / 10) + ((downstream_mir - downstream_mir * 1 / 10) * 0.02)) * 950 / 1000)*mod + (((upstream_mir * 1 / 10) + ((upstream_mir - upstream_mir * 1 / 10) * 0.02)) * 2100 / 1000))*dura;

      return Math.round(price * 100)/100;    }



  }//ende t11n

  else if (network_name === 'Eutelsat 12WA') {


    if (service_type.indexOf('dedicated') === 0) {
      price = ((baseprice + (((downstream_mir * 1 / 1) + ((downstream_mir - downstream_mir * 1 / 1) * 0.02)) * 950 / 1000) *mod + (((upstream_mir * 1 / 1) + ((upstream_mir - upstream_mir * 1 / 1) * 0.02)) * 2100 / 1000)) * dura);

      return Math.round(price * 100)/100;   
     }

     if (service_type.indexOf('shared-2') === 0) {
      price = ((baseprice + (((downstream_mir * 1 / 2) + ((downstream_mir - downstream_mir * 1 / 2) * 0.02)) * 950 / 1000) *mod + (((upstream_mir * 1 / 2) + ((upstream_mir - upstream_mir * 1 / 2) * 0.02)) * 2100 / 1000)) * dura);

      return Math.round(price * 100)/100;    }

    else if (service_type.indexOf('shared-4') === 0) {


      price = ((baseprice + (((downstream_mir * 1 / 4) + ((downstream_mir - downstream_mir * 1 / 4) * 0.02)) * 950 / 1000) *mod + (((upstream_mir * 1 / 4) + ((upstream_mir - upstream_mir * 1 / 4) * 0.02)) * 2100 / 1000)) * dura);

      return Math.round(price * 100)/100;    }

    else if (service_type.indexOf('shared-10') === 0) {


      price = ((baseprice + (((downstream_mir * 1 / 10) + ((downstream_mir - downstream_mir * 1 / 10) * 0.02)) * 950 / 1000) * mod + (((upstream_mir * 1 / 10) + ((upstream_mir - upstream_mir * 1 / 10) * 0.02)) * 2100 / 1000)) * dura);

      return Math.round(price * 100)/100;    }

  }


  else if (network_name === 'Arabsat 5C') {


    if (service_type.indexOf('dedicated') === 0) {

      price = ((baseprice + (((downstream_mir * 1 / 1) + ((downstream_mir - downstream_mir * 1 / 1) * 0.02)) * 950 / 1000) * mod + (((upstream_mir * 1 / 1) + ((upstream_mir - upstream_mir * 1 / 1) * 0.02)) * 2100 / 1000)) * dura);

      return Math.round(price * 100)/100;    }

    else if (service_type.indexOf('shared-2') === 0) {
      price = ((baseprice + (((downstream_mir * 1 / 2) + ((downstream_mir - downstream_mir * 1 / 2) * 0.02)) * 950 / 1000) * mod + (((upstream_mir * 1 / 2) + ((upstream_mir - upstream_mir * 1 / 2) * 0.02)) * 2100 / 1000)) * dura);

      return Math.round(price * 100)/100;    }

    else if (service_type.indexOf('shared-4') === 0) {


      price = ((baseprice + (((downstream_mir * 1 / 4) + ((downstream_mir - downstream_mir * 1 / 4) * 0.02)) * 950 / 1000) * mod + (((upstream_mir * 1 / 4) + ((upstream_mir - upstream_mir * 1 / 4) * 0.02)) * 2100 / 1000)) * dura);

      return Math.round(price * 100)/100;    }

    else if (service_type.indexOf('shared-10') === 0) {


      price = ((baseprice + (((downstream_mir * 1 / 10) + ((downstream_mir - downstream_mir * 1 / 10) * 0.02)) * 950 / 1000) * mod + (((upstream_mir * 1 / 10) + ((upstream_mir - upstream_mir * 1 / 10) * 0.02)) * 2100 / 1000)) * dura);

      return Math.round(price * 100)/100;    }

  }



};


class PriceCalculator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      network_name: null,
      service_type: '',
      downstream_mir: 0,
      upstream_mir: 0,
      modulation: '',
      duration: '',
    };
  }

  componentWillMount = () => {  //funktion call bevor irgendwas passiert
    this.props.loadNetworks();
  };

  componentDidMount = () => {   //funktion call nachdem irgendwas passiert
    this.props.updateQueryParams(this.props);
  };

  onNetworkChange = (event, target) => {
    const network_name = target.value;
    const network = this.props.networks.find((n) => n.network === network_name);
    this.setState({ network_name: network_name });
    //this.state.network = network;
    this.props.router.push('/calculator/' + network.network);
  };

  onDownstreamChange = (value) => {
    this.setState({ downstream_mir: value });
    this.props.updateQueryParams(this.state);
  }
  onDownstreamInputChange = (event) => {
    this.setState({ downstream_mir: event.target.value });
    this.props.updateQueryParams(this.state);
  }
  onUpstreamChange = (value) => {
    this.setState({ upstream_mir: value });
    this.props.updateQueryParams(this.state);
  }
  onUpstreamInputChange = (event) => {
    this.setState({ upstream_mir: event.target.value });
    this.props.updateQueryParams(this.state);
  }
  onServiceTypeChange = (event, target) => {
    this.setState({ service_type: target.value });
    this.props.updateQueryParams(this.state);
  }

  onModulationChange = (event, target) => {
    this.setState({ modulation: target.value });
    this.props.updateQueryParams(this.state);
  }

  onDurationChange = (event, target) => {
    this.setState({ duration: target.value });
    this.props.updateQueryParams(this.state);
  }


  render() {
    const network = this.props.networks.find(e => { return e.network === this.props.params.network_name });

    const serviceTypes = (network ? network.service_types : []).map(st => { return { text: st, value: st } });


    const networks = this.props.networks.map((e) => { return { text: e.network, value: e.network } });
    const price = calculatePrice(this.state);

    const modulation = (network ? network.modulation : []).map(st => { return { text: st, value: st } });
    const duration = (network ? network.duration : []).map(st => { return { text: st, value: st } });

    let body;
    console.log(network);

    if (network) {
      body = (<div>
        {/* <SiteMap shapes={network.shape_files}/>  */}
        <Dropdown placeholder='Select a service type' fluid selection options={serviceTypes} onChange={this.onServiceTypeChange} value={this.state.service_type} zIndex={99999999999999999999999}>
        </Dropdown>
        <Dropdown placeholder='Select a modulation' fluid selection options={modulation} onChange={this.onModulationChange} value={this.state.modulation}  zIndex={99999999999999999999999}>
        </Dropdown>
        <Dropdown placeholder='Select a timeduration' fluid selection options={duration} onChange={this.onDurationChange} value={this.state.duration} zIndex={99999999999999999999999}>
        {/* <as> months</as> */}
        </Dropdown>
        <Header as="h2">Price: {price !== null ? price + " USD " : "N/A"}</Header>
        <hr />

        <Input label="Downstream (kbit/s)" type="number" onChange={this.onDownstreamInputChange} value={this.state.downstream_mir} />
        <Slider min={network.min_downstream} max={network.max_downstream} value={this.state.downstream_mir} onChange={this.onDownstreamChange} step={250} />
        <Input label="Upstream (kbit/s)" type="number" onChange={this.onUpstreamInputChange} value={this.state.upstream_mir} />
        <Slider min={network.min_upstream} max={network.max_upstream} value={this.state.upstream_mir} onChange={this.onUpstreamChange} step={250} />
        <hr />


      </div>
      );
    }

    return (
      <Container>
        <Dimmer active={this.props.loading}>
          <Loader>Loading…</Loader>
        </Dimmer>
        <Header as="h1">Price Calculator</Header>
        <Dropdown placeholder="Select a network" fluid selection options={networks} onChange={this.onNetworkChange} />
        {body}
      </Container>
    );
  }

}


var updateQueryParams = (dispatch, location, props = null) => {
  var query = {
    ...location.query,
    service_type: props.service_type || 'dedicated',
    downstream_mir: props.downstream_mir || 0,
    upstream_mir: props.upstream_mir || 0,
    network_name: props.network_name || null,
    modulation: props.modulation || '13.8',
    duration: props.duration || '1'
  };
  dispatch(push({ ...location, query: query }));

};


const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadNetworks: () => {
      dispatch(getPrices());
    },
    updateQueryParams: (props) => {
      return updateQueryParams(dispatch, ownProps.location, props);
    }
  }
};

const mapStateToProps = (s, ownProps) => {
  const state = s.pricesReducer;
  return {
    loading: state.loading,
    networks: state.networks,
  };
}

//export default connect(mapDispatchToProps)(PriceCalculator);
export default connect(mapStateToProps, mapDispatchToProps)(PriceCalculator);



// WEBPACK FOOTER //
// ./src/views/PriceCalculator.js